// extracted by mini-css-extract-plugin
module.exports = {"homeTool_content":"scaleSkeleton_homeTool_content__32XFQ","title":"scaleSkeleton_title__34eJV","content":"scaleSkeleton_content__1U5HF"};